<template>
  <div id="login">
    <div class="login_logo">
      <div class="img">
        <img src="@/assets/img/logosvg.svg" />
      </div>
      <div class="title">Sign in or create an account</div>
    </div>
    <div class="login">
      <div class="language">
         <languageTranslation></languageTranslation>
      </div>
      <div id="login_lo">
        <div class="title2">Create your account</div>
      </div>
      <div class="login_input">
        <div class="login_input_title">Your Email Address</div>
        <input
          v-model="logins.email"
          :placeholder="$t('Your Email')"
          :class="code == 1 ? '' : 'error'"
        />
        <div class="Tips">{{ code ? "" : msg }}</div>
      </div>
      <div class="explain">
        <el-checkbox
          :class="{ isChecked: !isChecked }"
          v-model="checked"
        ></el-checkbox>
        <div>
          By clicking on the Sign up button, you are agreeing to our
          <a href="https://www.spylix.com/eula.html">Terms of Use </a>
          and
          <a href="https://www.spylix.com/privacy-policy.html" class=""
            >Privacy Policy</a
          >
        </div>
      </div>
      <div @click="foem()" class="loginButton">Sign up</div>
      <router-link :to="{ name: 'login' }" class="login_a router-link-active"
        >Sign in</router-link
      >
      <div class="tagging">If you already have a Spylix account.</div>
    </div>
  </div>
</template>

<script>
import { userRegister } from '@/api/user'
export default {
  name: 'HelloWorld',
  data () {
    return {
      logins: {
        email: '',
        event: 'register'
      },
      code: 1,
      msg: '',
      checked: true,
      isChecked: true
    }
  },
  mounted () {},
  methods: {
    foem () {
      this.isChecked = true
      if (!this.checked) {
        this.isChecked = false
        // this.code = 0
        // this.msg = 'Please accept the terms and conditions'
        return false
      }
      userRegister(this.logins).then((adj) => {
        this.code = adj.code
        if (this.code === 1) {
          localStorage.setItem('avatar', adj.data.userinfo.avatar)
          localStorage.setItem('id', adj.data.userinfo.id)
          localStorage.setItem('nickname', adj.data.userinfo.nickname)
          localStorage.setItem('email', adj.data.userinfo.email)
          localStorage.setItem('token', adj.data.userinfo.token)
          this.$router.push({ name: 'systemTest' })
        }
        this.msg = adj.msg
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.el-checkbox:last-of-type {
  margin-right: 8px;
}
#login {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: url(./../assets/img/login.png);
  background-size: 100% auto;
  color: #fff;
}
.login_logo {
  position: absolute;
  top: 45%;
  right: 70%;
}
.login_logo .img,
.login_logo .img img {
  width: 170px;
}
.login_logo .title {
  font-size: 16px;
  line-height: 50px;
}
.login {
  width: 500px;
  height: 600px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -300px 0 0;
  background: #fff;
  border-radius: 20px;
}
.login .language {
  position: absolute;
  right: 20px;
  top: 20px;
  /* width: 40px; */
  /* height: 20px; */
  overflow: hidden;
}
.login .language .flag {
  border-radius: 8px;
}
.login .language .dow,
.login .language .flag {
  width: 16px;
  height: 16px;
  overflow: hidden;
  float: left;
  position: relative;
  margin: 2px;
}
.login .language img {
  width: 100%;
  height: 100%;
  top: 0;
  position: absolute;
  left: 0;
}
#login_lo {
  width: 360px;
  margin: 0 auto;
  color: #000;
  text-align: left;
}
#login_lo .title {
  font-size: 32px;
  font-weight: 700;
  font-family: Noto Sans;
  margin: 60px 0 30px;
}
#login_lo .title2 {
  font-size: 24px;
  font-weight: 700;
  font-family: Noto Sans;
  line-height: 36px;
  margin: 60px 0 30px;
  color: #000927;
}
#login_lo .ftitle {
  font-size: 13px;
  font-family: Noto Sans;
  line-height: 20px;
  color: #9f9f9f;
  margin-bottom: 20px;
}
.login_input {
  width: 360px;
  margin: 0 auto;
  padding-bottom: 10px;
  text-align: left;
  position: relative;
}
.login_input .login_input_title {
  font-size: 14px;
  line-height: 30px;
  color: #000927;
  font-family: Noto Sans;
}
.login_input input {
  height: 48px;
  width: 358px;
  border-radius: 8px;
  border: 1px solid #d5d7db;
  text-indent: 1em;
  font-size: 14px;
  padding: 0;
}
.login_input input:focus {
  border: 1px solid #00eec3;
}
.login_input input.error {
  border: 1px solid #f54545;
}
.login_input_eye {
  position: absolute;
  bottom: 10px;
  right: 16px;
  width: 16px;
  height: 16px;
  bottom: 28px;
}
.loginButton {
  width: 360px;
  height: 50px;
  border-radius: 25px;
  background: #00eec3;
  font-size: 16px;
  font-weight: 700;
  color: #000927;
  line-height: 50px;
  margin: 90px auto 50px;
  -webkit-box-shadow: 0 2px 6px rgba(8, 145, 120, 0.5);
  box-shadow: 0 2px 6px rgba(8, 145, 120, 0.5);
}
.Tips {
  width: 360px;
  height: 16px;
  text-align: left;
  color: #f54545;
  font-size: 12px;
  margin: 10px auto 10px;
}
.login_a {
  font-size: 14px;
  text-align: center;
  color: #0080ff;
  display: block;
  margin-bottom: 0;
  line-height: 20px;
}
.tagging {
  font-size: 12px;
  text-align: center;
  color: #9f9f9f;
  display: block;
  line-height: 20px;
  font-family: Noto Sans;
}
.explain {
  display: flex;
  width: 360px;
  margin: 0 auto 20px auto;
  color: #9f9f9f;
  text-align: left;
  font-size: 13px;
  line-height: 20px;
  font-family: Noto Sans;
  font-family: Noto Sans;
  font-size: 13px;
  color: #9f9f9f;
  letter-spacing: 0;
  line-height: 18px;
  font-weight: 400;
}
.explain img {
  float: left;
  width: 16px;
  height: 16px;
  margin: 0 6px 6px 0;
}
.explain a {
  color: #0080ff;
}
</style>



// WEBPACK FOOTER //
// src/components/accountTest.vue